"use strict";
exports.__esModule = true;
exports.getTruncatedLabels = void 0;
var CONNECTOR = ", ";
var truncateByCharacterLimit = function (labels, limit, labelsTruncatedCount) {
    if (labelsTruncatedCount === void 0) { labelsTruncatedCount = 0; }
    if (labels.length === 1 || labels.join("").replace(/,/g, "").length < limit) {
        var moreIndicator = labelsTruncatedCount > 0 ? " + ".concat(labelsTruncatedCount, " more") : "";
        return "".concat(labels.join(CONNECTOR)).concat(moreIndicator);
    }
    var newLabels = labels.slice(0, labels.length - 1);
    return truncateByCharacterLimit(newLabels, limit, labelsTruncatedCount + 1);
};
var getTruncatedLabels = function (labels, limit) {
    return truncateByCharacterLimit(labels, limit);
};
exports.getTruncatedLabels = getTruncatedLabels;
//# sourceMappingURL=getTruncatedLabel.js.map